import type { SongSubmissionScore } from '../../../../shared/api/round.ts';

export const guessVerdictByScoreType: Partial<Record<SongSubmissionScore['scoreType'], string>> = {
  correct: 'Perfect guess! 🎯',
  'partially-correct': 'So close! You got the artist right. 🤏',
  wrong: 'Not quite this time, but keep going! 🚀',
};
